import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_gd86yguu29: FaireBrandEntity = {
  token: "b_gd86yguu29",
  type: "brand",
  name: "NINEXIS",
  avatarUrl:
    "https://cdn.faire.com/fastly/b358e060c56c91d0fdcbe2abdc8146f549631f5b5b68a60d4ae18b504687e75a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/bfc724a7c6e2a380c7bfbcd0285320e5efb6fa5d9f5fccdcea275c934be341b8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b358e060c56c91d0fdcbe2abdc8146f549631f5b5b68a60d4ae18b504687e75a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/bfc724a7c6e2a380c7bfbcd0285320e5efb6fa5d9f5fccdcea275c934be341b8.jpeg",
  location: "CA, USA",
  minimumOrderDollars: 150,
  rating: 4.4,
  reviewCount: 751,
  isInsider: true,
  description:
    "Shortly after NINEXIS launched in May 2013, NINEXIS found great success with online shoppers who are looking for that go-to everyday day wear.\n\nOur customers are women who want to look and feel like themselves - always. You will find NINEXIS styles fitting any occasion and mood whether you are looking for something chic, relaxed, elegant or sporty.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:56.807Z",
    importedBy: "entity-db-cli",
  },
};
